import React, { FC, useState } from "react";

import FilterListIcon from "@mui/icons-material/FilterList";
import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";

import { Translate } from "@/components/Application/Translate";

type Props = {
	sortOrder: string;
	setSortOrder: (order: "ASC" | "DESC") => void;
};

const SortMenu: FC<Props> = (props: Props) => {
	const { sortOrder, setSortOrder } = props;
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleMenuItemClick = (order: "ASC" | "DESC") => {
		setSortOrder(order);
		handleClose();
	};

	return (
		<Box display="inline-flex" justifySelf="end">
			<IconButton
				aria-controls="filter-menu"
				aria-haspopup="true"
				onClick={handleClick}
			>
				<FilterListIcon />
			</IconButton>
			<Menu
				id="filter-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				<MenuItem
					selected={sortOrder === "ASC"}
					onClick={() => handleMenuItemClick("ASC")}
				>
					<Typography variant="caption">
						{" "}
						<Translate String="Common.Filters.ASC">Oldest to Newest</Translate>
					</Typography>
				</MenuItem>
				<MenuItem
					selected={sortOrder === "DESC"}
					onClick={() => handleMenuItemClick("DESC")}
				>
					<Typography variant="caption">
						{" "}
						<Translate String="Common.Filters.ASC">Newest to Oldest</Translate>
					</Typography>
				</MenuItem>
			</Menu>
		</Box>
	);
};

export default SortMenu;
